import { CalendarIcon } from "@chakra-ui/icons";
import { Button, Card, CardBody, CardHeader, Heading } from "@chakra-ui/react";
import type { APIListing } from "models/types/api-listing";
import { Link } from "react-router-dom";
import { CardRecord } from "components/cards/card-record";
import { SkeletonList } from "modules/vendor-portal/components/skeleton-list";
import { VENDOR_PORTAL_PATHS } from "modules/vendor-portal/paths";
import { FeedbackIcon } from "modules/vendor-portal/screens/overview/components/feedback/feedback-icon";
import { formatAPIEventDateTimeTitle } from "modules/vendor-portal/screens/overview/components/open-home-events/event-card";
import { EventCardSkeleton } from "modules/vendor-portal/screens/overview/components/open-home-events/event-card-skeleton";
import { EventFooter } from "modules/vendor-portal/screens/overview/components/open-home-events/footer/event-footer";

type EventSummaryContainerProps = {
  events: NonNullable<APIListing["events"]>;
  isLoading: boolean;
  title: string;
};

export function EventSummaryContainer({
  events,
  isLoading,
  title,
}: EventSummaryContainerProps) {
  return (
    <Card h={"100%"}>
      <CardHeader
        display={"flex"}
        flexDir={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        p={6}
        pb={0}
      >
        <Heading fontSize={"xl"}>{title}</Heading>
        <Link to={"events"}>
          <Button variant={"solid"} colorScheme={"gray"}>
            View all
          </Button>
        </Link>
      </CardHeader>
      <CardBody px={4} pt={1} pb={2}>
        <SkeletonList isLoaded={!isLoading} skeleton={<EventCardSkeleton />}>
          {events.slice(0, 3).map((event) => (
            <CardRecord
              key={event.id}
              leftElement={<FeedbackIcon icon={CalendarIcon} />}
              heading={formatAPIEventDateTimeTitle(event)}
              style={{ border: "none" }}
              renderCallToActionButton={
                event.type.id === "open_home" && !!event.feedback
                  ? (props) => (
                      <Button
                        as={Link}
                        to={`${VENDOR_PORTAL_PATHS.EVENTS}/${event.id}`}
                        variant={"link"}
                        {...props}
                      >
                        View details
                      </Button>
                    )
                  : undefined
              }
            >
              <EventFooter event={event} />
            </CardRecord>
          ))}
        </SkeletonList>
      </CardBody>
    </Card>
  );
}
